<template>
  <div v-if="visible">
    <el-dialog
      :visible="visible"
      :title="title"
      :width="width"
      :top="top"
      :before-close="handleClose"
      :close-on-click-modal="closeOnModal"
      :close-on-press-escape="false"
      :destroy-on-close="destroyOnClose"
      :class="['base-dialog', commClass]"
      append-to-body
    >
      <div
        v-if="!closeOnModal"
        slot="title"
        class="basic-dialog-title"
      >
        <span>{{ title }}</span>
        <img
          src="@/static/img/close-icon.png"
          class="close-icon"
          @click="handleClose"
        >
      </div>
      <slot />
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    destroyOnClose: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '400px'
    },
    top: {
      type: String,
      default: '15vh'
    },
    commClass: {
      type: String,
      default: ''
    },
    closeOnModal: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClose () {
      this.$emit('close')
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="stylus">
.base-dialog
  .el-dialog
    border-radius 2px
    box-shadow 0px 1px 4px 0px rgba(0, 0, 0, 0.35)
  .el-dialog__header
    padding 24px 0px
    border-radius 8px 8px 0px 0px
    // background-color #BD2124
    text-align left
    padding-left 20px
    border-bottom 1px solid #eee
  .el-dialog__headerbtn
    display none
    top 20px
  .el-dialog__title
    font-size 18px
    color #fff
  .el-dialog__headerbtn .el-dialog__close
    font-size 20px
  .el-dialog__body
    padding 20px
    color #333
    font-family PuHuiTi-Regular
.basic-dialog-title
  position relative
  color #333333
  font-size 20px
.close-icon
  cursor pointer
  position absolute
  right 20px
  top 50%
  transform translateY(-50%)
  width 14px
  height 14px
  transition all 0.2s ease-in-out
  &:hover
    opacity 0.6
.no-header
  .el-dialog__header
    display none
.pay-dialog
  .el-dialog__header
    display none
  .el-dialog__body
    padding 0px
    color #333
</style>
